import { ReactNode } from "react"
import css from "@css/modules/DealScroeDialog.module.scss"

type StatItemProps = { image: ReactNode; imgText: string; children: ReactNode }

export function StatItem({ image, imgText, children }: StatItemProps) {
    return (
        <div className={css.statItem}>
            <div className={css.statItemIcon}>
                {image}
                {imgText}
            </div>
            <div className={css.statItemDesc}>{children}</div>
        </div>
    )
}
